/* 
	Catalog Category component is used to show the books by category on catalog site
	This component accepts following proptypes.
	@param props - data returned by the API, page slug, page number and sitesetting
*/

import React from "react";
import { useAppContext } from "@components/Provider";
import Meta from "../Meta";
import { RenderHomePageSchema } from "../../helpers/Helper";
import PropTypes from "prop-types";
import Device from "../../constants/Device";
import PageBuilder from "../../helpers/PageBuilder";

import styles from "./CatalogHome.module.css";

const CatalogHome = (props) => {
  props = props.HomeData;
  let { data, host, siteId, isMobile } = useAppContext(),
    [catelogHomePageData] = (props && props.data) || [],
    { post } = (catelogHomePageData && catelogHomePageData.Index) || {},
    { SiteSettings } = data || {},
    siteName = SiteSettings.site_name,
    pageBuilderOptions = {
      deviceSize: Device.DESKTOP,
      Newsletter_Settings: SiteSettings.newsletter_settings,
      homePage: true,
    };
  return (
    <div
      className={
        isMobile
          ? [
              styles["HomePageSection"],
              props.classes["HomePageSection"],
              styles["topPadding"],
              "topPadding",
            ].join(" ")
          : [styles["HomePageSection"], props.classes["HomePageSection"]].join(
              " "
            )
      }
    >
      <PageBuilder
        post={post}
        pageBuilderOptions={pageBuilderOptions}
        siteId={siteId}
        classes={props.classes}
        dealsData={props?.dealsData}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={RenderHomePageSchema(
          SiteSettings,
          post,
          host,
          siteId
        )}
      />
      <Meta
        url={props.pageUrl}
        post={post}
        siteName={siteName}
        isNewAppRouter={true}
      />
    </div>
  );
};

CatalogHome.propTypes = {
  props: PropTypes.object,
};

export default CatalogHome;
